import { render, staticRenderFns } from "./ListFolio.vue?vue&type=template&id=24cc8ec4&"
import script from "./ListFolio.vue?vue&type=script&lang=js&"
export * from "./ListFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports